<template>
  <div v-if="loading" class="loading-wr position-relative">
    <pre-loader/>
  </div>
  <div v-else :class="{'mx-2': $store.state.isMobile, 'mb-2': sliderEvents.length}">

    <div v-if="!hideHeader && sliderEvents.length" class=" mb-2 fw-600 fs-6 p-n sub-header geoff-bg-section" :class="{'rounded-3': !$store.state.isMobile}">
      <div>Results Feed</div>
    </div>

    <swiper
      v-if="sliderEvents"
      slidesPerView="auto"
      :centeredSlides="false"
      :spaceBetween="8"
      :navigation="$store.state.isMobile ? false : true"
      :modules="modules"
      :breakpoints="breakpoints"
      :loop="false"
      class="swiper-nav-semitransparent">

      <swiper-slide
        v-for="(event, index) in sliderEvents"
        :key="index"
        class="slide-item-wr"
        :class="{
          'desktop-slide': !$store.state.isMobile,
          'mobile-slide': $store.state.isMobile
          }"
      >
        <race-results-slider-item :event="event"/>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import PreLoader from "@/components/UI/PreLoader";
import RaceResultsSliderItem from "@/components/Home/RaceResultsSliderItem";
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";

export default {
  name: "RaceResultsSlider",
  components: { 
    PreLoader,
    RaceResultsSliderItem,
    Swiper, 
    SwiperSlide, 
  },
  setup() {
    return {
      modules: [Navigation],
    };
  },
  props: {
    sportName: {
      type: String,
    },
    sportCode: {
      type: String,
    },
    hideHeader: {
      type: Boolean,
    }
  },
  data: ()=>{
    return {
      loading: true,
      sliderEvents: [],
      intervalLoad: null,
      
    }
  },
  computed: {
    breakpoints() {
      return this.$store.state.isMobile ?  
        {} :  {
          // when window width is >= XXXpx
          1: { // 760 
            slidesPerView: 2,
            spaceBetween: 8
          },
          1120: { // 1108
            slidesPerView: 3,
            spaceBetween: 8
          },
          1500: { // 1481
            slidesPerView: 4,
            spaceBetween: 8
          },
        }
    }
  },
  mounted() {
    this.loadEvents();
    this.intervalLoad = setInterval(()=>this.loadEvents(), 5000)
  },
  beforeUnmount(){
    if (this.intervalLoad) clearInterval(this.intervalLoad)
  },
  methods:{
    loadEvents(){
      this.API.getLastRacesResults(this.sportCode)
        .then(data => {
          this.sliderEvents = data
          this.loading = false
        })
        .catch(error=>{console.log(error), this.loading=false})
    }
  },
}
</script>

<style scoped lang="scss">
  .loading-wr {
    min-height: 150px;
  }

  .slide-item-wr {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--geoff-bg-section);
    border-radius: 0.25rem;

    &.mobile-slide {
      width: calc((100% - 1.5rem)/4 );

      @media only screen and (max-width: 900px) {
        width: calc((100% - 0.5rem)/3 - 1rem);
      }
      @media only screen and (max-width: 700px) {
        width: calc((100% - 0.5rem)/2 - 1rem);
      }

      @media only screen and (max-width: 430px) {
        width: calc((100%) - 2rem);
      }
    }

    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }

    &.desktop-slide {
      width: unset;
      max-width: unset;
    }

  }

</style>